import { render, staticRenderFns } from "./resultat.vue?vue&type=template&id=41e22a59&scoped=true&"
import script from "./resultat.vue?vue&type=script&lang=js&"
export * from "./resultat.vue?vue&type=script&lang=js&"
import style0 from "./resultat.vue?vue&type=style&index=0&id=41e22a59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e22a59",
  null
  
)

export default component.exports